/** @format */
import React,{ useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { supportService } from '../../Services/support.service';

const quillModules = {
	toolbar: [
		[{ header: [1, 2, 3, false] }],
		['bold', 'italic', 'underline', 'strike'],
		[{ list: 'ordered' }, { list: 'bullet' }],
		[{ color: [] }, { background: [] }],
		['link', 'image'],
		['clean'],
	],
};

const AddSupport = ({ onSuccess, setResultModal, disabled, languages }) => {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});
	const [content, setContent] = useState('');
	const [contentError, setContentError] = useState(false);

	const onSubmit = data => {
		if (!content || content === '<p><br></p>') {
			setContentError(true);
			return;
		}
		setContentError(false);
		supportService
			.create({ ...data, languageId: parseInt(data.languageId), priority: parseInt(data.priority), content })
			.then(res => {
				onSuccess();
				setContent('');
				setResultModal({
					show: true,
					title: translator('Support-Add-SuccessModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}>
			<fieldset className='scheduler-border'>
				<div className='form-group'>
					<label>{translator('Support-Language')}</label>
					<select
						className='form-control'
						ref={register({ required: true })}
						name='languageId'
						disabled={disabled}>
						<option value=''>{translator('Support-SelectLanguage')}</option>
						{languages && languages.map(lang => (
							<option key={lang.id} value={lang.id}>{lang.name}</option>
						))}
					</select>
					{errors.languageId && errors.languageId.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Support-Title')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({ required: true, maxLength: 100 })}
						name='title'
						disabled={disabled}
					/>
					{errors.title && errors.title.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.title && errors.title.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength100')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Support-Priority')}</label>
					<input
						type='number'
						className='form-control'
						ref={register({ required: true, min: 0 })}
						name='priority'
						disabled={disabled}
					/>
					{errors.priority && errors.priority.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Support-Content')}</label>
					<ReactQuill
						value={content}
						onChange={setContent}
						modules={quillModules}
						readOnly={disabled}
						theme='snow'
					/>
					{contentError && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
				</div>
			</fieldset>

			<div className='d-flex justify-content-end mt-2'>
				<button className='btn btn-primary' type='submit' disabled={disabled}>
					{translator('Btn-Save')}
				</button>
			</div>
		</form>
	);
};

export default AddSupport;
